<div class="fullscreen mh-100 mw-100 d-flex-column">
  <div class="flex-fill">
    <img class="logo w-100 h-100" alt="logo" src="/assets/logos/{{match.logo}}">
  </div>
<!--  <app-social-info [text]="match.social"></app-social-info>-->
</div>
<div class="dimmer fullscreen"></div>
